<template>
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Arrow">
            <path id="Path 6456" d="M1.82324 1.65372L7.82401 7.65448L13.8248 1.65372" stroke="#5F5F63" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconChevronDown"
}
</script>

<style scoped>

</style>
